import { render, staticRenderFns } from "./billing-premium-label.vue?vue&type=template&id=46608963&scoped=true&lang=pug"
import script from "./billing-premium-label.vue?vue&type=script&lang=js"
export * from "./billing-premium-label.vue?vue&type=script&lang=js"
import style0 from "./billing-premium-label.vue?vue&type=style&index=0&id=46608963&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46608963",
  null
  
)

export default component.exports